import { Button, Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useDeleteTaxReturns } from '../../api/report/report';
import { useDefaultModalStyles } from '../../hooks/useDefaultModalStyles';
import { BaseStackResponse } from '../../model';
import Modal from './ModalV9';

export interface IConfirmReturnDeletionModalProps {
    isModalVisible: boolean;
    returnKey: number | undefined;
    onCancel: () => void;
    onConfirm: (returnKey: number, response: BaseStackResponse) => void;
}

const ConfirmReturnDeletionModal = ({ isModalVisible, onConfirm, onCancel, returnKey }: IConfirmReturnDeletionModalProps) => {
    const { t } = useTranslation();
    const { button } = useDefaultModalStyles();
    const { mutateAsync: deleteTaxReturn, isLoading } = useDeleteTaxReturns();

    const handleConfirm = async () => {
        if (returnKey) {
            const response = await deleteTaxReturn({ data: { keys: [returnKey] } });
            onConfirm(returnKey, response);
        }
    };

    const buttons = (
        <>
            <Button
                appearance='primary'
                size='small'
                aria-label={t('delete').toString()}
                onClick={handleConfirm}
                disabled={Boolean(isLoading)}
                data-testid='confirm-delete-return'
                className={button}
            >
                {isLoading ? t('working').toString() : t('delete').toString()}
                {isLoading && <Spinner size='extra-tiny' />}
            </Button>
            <Button
                size='small'
                aria-label={t('cancel').toString()}
                onClick={onCancel}
                data-testid='cancel-delete-return'
                className={button}
            >
                {t('cancel').toString()}
            </Button>
        </>
    );

    return (
        <Modal
            headerContent={t('confirmDeletion')}
            bodyContent={<div style={{ maxWidth: 550 }}>{t('confirmReturnDeletionDescription')}</div>}
            isOpen={isModalVisible}
            onClose={onCancel}
            buttons={buttons}
        />
    );
};

export default ConfirmReturnDeletionModal;
